/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */

import MyReview from './pages/MyReview.vue';
import ReviewForm from './pages/ReviewForm.vue';
import CycleList from './pages/CycleList.vue';
import CycleSave from './pages/CycleSave.vue';
import ReviewList from './pages/ReviewList.vue';
import ReviewDetail from './pages/ReviewDetail.vue';
import Designees from './pages/Designees.vue';

export default {
  'apcwo-pr-my-review': MyReview,
  'apcwo-pr-review-form': ReviewForm,
  'apcwo-pr-cycle-list': CycleList,
  'apcwo-pr-cycle-save': CycleSave,
  'apcwo-pr-review-list': ReviewList,
  'apcwo-pr-review-detail': ReviewDetail,
  'apcwo-pr-designees': Designees,
};
